import "normalize.css";
import { run } from "./main";
import { bootloadPrimitives } from "./primitives";
import { getParam } from "./utils";

const getBrowserComponents = () => {
  const canvas = document.querySelector("canvas");
  const ctx = bootloadPrimitives(canvas.getContext("2d"));

  return Promise.resolve({
    canvas,
    ctx,
  });
};

run(getBrowserComponents, {
  seed: getParam("seed"),
  debug: !!getParam("debug"),
});

document.querySelector("canvas").addEventListener("click", () => {
  window.history.pushState({}, null, `${window.location.pathname}`);
  run(getBrowserComponents);
});
